import * as React from 'react';
import { DataLayer } from '@grandvisionhq/analytics';
import { useIntl, useFeatureToggles } from '@grandvisionhq/state';
import { monetate } from '@grandvisionhq/svc-monetate';
import { isDefined } from '@grandvisionhq/utils';
import { createImpressionObject, createInteractionEvent, createImpressionEvent } from '../Events/ProductListingPageEvents.js';

const usePlpDatalayerEvents = ()=>{
    const { currency  } = useIntl();
    const { isMonetateProductDataEnabled  } = useFeatureToggles();
    const impressionEvent = createImpressionEvent(currency);
    const { atfEcommerce: { ecommerce: { impressions  } ,  } ,  } = impressionEvent;
    const addImpressionEvent = React.useCallback((product, position)=>{
        impressions.push(createImpressionObject(product, position));
    }, []);
    const trackMonetateImpressions = (products)=>{
        monetate().trackProductListing(isMonetateProductDataEnabled ? products.filter(isDefined).map((product)=>({
                sku: product.masterVariant.sku || ''
            })
        ) : []);
    };
    const pushImpressionsToDatalayer = ()=>{
        DataLayer.pushEvent(impressionEvent);
    };
    const pushProductClickToDatalayer = React.useCallback((product, position)=>{
        DataLayer.pushEvent(createInteractionEvent(product, position, `category: ${product.productType}`, currency));
    }, []);
    return {
        addImpressionEvent,
        trackMonetateImpressions,
        pushImpressionsToDatalayer,
        pushProductClickToDatalayer
    };
};

export { usePlpDatalayerEvents };
//# sourceMappingURL=use-plp-datalayer-events.js.map
